import type { ClaudeAccount } from "./bridge";

/**
 * Whose Claude plan employees run on here, for the worker popover and first run.
 * A missing login is the one case in attention: Claude plan employees cannot run until someone logs in.
 */
export function ClaudePlanText({ account }: { account: ClaudeAccount | undefined }) {
  if (account === undefined) return <span className="text-text-2">Checking the Claude login.</span>;
  if (account.email === null) {
    return (
      <>
        <span className="text-attention">No Claude login in {account.configDir}.</span>
        <span className="text-text-2"> Run claude in a terminal and log in.</span>
      </>
    );
  }
  return (
    <span className="text-text-2">
      Employees use <span className="text-text">{account.email}</span>'s Claude plan.
    </span>
  );
}
